import modularScale from 'modularscale-js';

const ms = (n: number): number => (
  modularScale(n, {
    base: [18],
    ratio: 1.25,
  })
);

export const typography = <const>{
  '-2': `${ms(-2)}px`, // 11.52px
  '-1': `${ms(-1)}px`, // 14.4px
  0: `${ms(0)}px`, // 18px
  1: `${ms(1)}px`, // 22.5px
  2: `${ms(2)}px`, // 28.125px
  3: `${ms(3)}px`, // 35.15625px
  5: `${ms(5)}px`, // 54.931640625px
};
